// Showroom catalog.
//
// Products and fabrics are edited by the business in the admin and serialised
// by Rails into a <script type="application/json"> in the page — the same trick
// the quote form uses for its options. Nothing about the catalog is written in
// this bundle any more: adding a blind is a form, not a deploy.
//
// The shape each product arrives in:
//
//   light      how much daylight the fabric lets through, 0 (full darkness) to
//              5 (almost no filtering). LightMeter draws it, and it is the fact
//              that actually decides a purchase.
//   adjustable the number above is a ceiling, not a fixed value: a duo, a doble
//              and a slatted blind go from that much light down to none. The
//              meter adds a "Regulable" tag so the ceiling is not mistaken for
//              a fixed amount.
//   width      intrinsic size of the photo, so the browser reserves the space
//   height     before it downloads and the page does not jump on load.
//   focus      object-position for the 4:5 card crop.
//   image      null when the product has no photo yet: the card draws a tonal
//              panel in its place — see the note in ProductCard — instead of an
//              empty box.
//
// Fabrics work the same way: `swatch` is null until a photo exists, and the
// square is drawn from `tone` and `pattern` ('weave' or 'bands').
//
// Los servicios son lo más simple del catálogo: nombre y descripción. No tienen
// foto ni ficha, porque un servicio se lee, no se mira.

function readCatalog () {
  const node = document.getElementById('site-catalog')
  const empty = { products: [], fabrics: [], services: [] }

  try {
    return node ? { ...empty, ...JSON.parse(node.textContent) } : empty
  } catch {
    return empty
  }
}

const catalog = readCatalog()

export const products = catalog.products
export const fabrics = catalog.fabrics
export const services = catalog.services

export const valueProps = [
  'Cotización sin costo',
  'Fabricación a medida',
  'Entrega de 5 a 7 días hábiles'
]

export const finishes = [
  { title: 'Accionamiento', note: 'Cadena, resorte o motor con control y app.' },
  { title: 'Instalación', note: 'A muro, a cielo o dentro del vano.' },
  { title: 'Perfiles', note: 'Cassette cerrado o tubo a la vista.' },
  { title: 'Medidas', note: 'Cada cortina se corta al milímetro del vano.' }
]

export const steps = [
  {
    title: 'Mide tu ventana',
    note: 'Ancho y alto en centímetros, dentro y fuera del vano.',
    href: '#medir',
    hrefLabel: 'Ver cómo medir'
  },
  {
    title: 'Cotizamos',
    note: 'Mándanos las medidas por el formulario o por WhatsApp y te llega el presupuesto por escrito.'
  },
  {
    title: 'Instalamos',
    note: 'Fabricamos a medida y la dejamos funcionando en tu ventana.'
  }
]

// The two ways to mount a blind, each with its rule. Copy taken from Casa
// Lumina's measuring instructions.
export const measuringGuides = [
  {
    id: 'inside',
    title: 'Dentro del vano',
    when: 'La cortina va entre las paredes, dentro del hueco de la ventana.',
    rule:
      'Mide el ancho y el alto del vano. Al ancho réstale 1 cm en total, medio centímetro por lado, para que la cortina entre y corra sin rozar el muro.',
    formula: 'Ancho del vano − 1 cm · Alto exacto'
  },
  {
    id: 'outside',
    title: 'Fuera del vano',
    when: 'La cortina se monta sobre el muro y tapa el marco.',
    rule:
      'Mide el ancho y el alto del marco de la ventana y agrégale 10 cm por lado. Ese sobrante es el que evita que entre luz por los costados.',
    formula: 'Marco + 10 cm por lado'
  }
]
